import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from 'components/shared/Checkbox'

class StylingProduct extends React.Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    bundleProduct: PropTypes.object,
    onChange: PropTypes.func,
  }

  descriptionLabel(label, description) {
    return (
      <div>
        <div>{label}</div>
        <div style={this.descriptionStyle}>{description}</div>
      </div>
    )
  }

  render() {
    if (this.props.bundleProduct) {
      return null
    }

    return (
      <div style={this.props.style}>
        <Checkbox
          checked={this.props.product.basic}
          style={{marginBottom: 10}}
          label="Interiørveiledning"
          description="Interiørveiledning i forkant av fotografering"
          onChange={e => this.props.onChange({basic: e.target.checked})}
        />

        <Checkbox
          checked={this.props.product.plus}
          style={{marginBottom: 10}}
          label="Interiørveiledning under fotografering"
          description="Interiørveiledning og assistanse samme dag som fotografering"
          onChange={e => this.props.onChange({plus: e.target.checked})}
        />
      </div>
    )
  }
}

export default StylingProduct
